export const routePaths = {
  home: '/',
  profile: '/profile',
  profileUser: '/user/:userId',
  notifications: '/notifications',
  creators: '/creators/:id',
  creatorsRequest: '/account/creator-request',
  creatorsSuggestion: '/creators/request',
  friend: 'friend',
  listFriend: 'list-friend',
  savePost: '/save-post',
  search: '/search',
  gate: '/gate',
  chat: '/chat',
  videos: '/videos',
  videoDetail: '/videos/:id',
  reels: '/reels',
  studio: '/studio',
  ads: '/ads',
  shop: '/affiliate',
  publisher: '/publisher',
  partner: '/partner',
  daoCa: '/mining',
  register: '/account/register',
  login: '/account/login',
  verifyEmail: '/account/verify-email',
  userSetting: '/settings',
  notiDonate: '/donate-screen/:contentCreatorId',
  // Overlay THANH TIẾN ĐỘ mục tiêu donate (chèn vào OBS, không cần đăng nhập).
  donateGoalScreen: '/donate-goal-screen/:contentCreatorId',
  // Overlay VÒNG QUAY (chèn vào OBS, không cần đăng nhập).
  spinWheelScreen: '/spin-wheel-screen/:contentCreatorId',
  // Overlay BÌNH CHỌN (chèn vào OBS, không cần đăng nhập).
  donatePollScreen: '/donate-poll-screen/:contentCreatorId',
  // Overlay THỬ THÁCH DONATE (chèn vào OBS, không cần đăng nhập).
  donateChallengeScreen: '/donate-challenge-screen/:contentCreatorId',
  // Overlay PHÁT NHẠC THEO YÊU CẦU (chèn vào OBS, không cần đăng nhập, link có ?key=).
  musicScreen: '/music-screen/:contentCreatorId',
  // Overlay HIỆU ỨNG TƯƠNG TÁC (chèn vào OBS, không cần đăng nhập, link có ?key=).
  liveEffectScreen: '/effect-screen/:contentCreatorId',
  // Overlay HỘI VIÊN KÊNH (chèn vào OBS, không cần đăng nhập, link có ?key=).
  memberScreen: '/member-screen/:contentCreatorId',
  // Overlay QUẢNG CÁO LIVESTREAM (chèn vào OBS, không cần đăng nhập, link có ?key=).
  adScreen: '/ad-screen/:slotId',
  // Overlay ĐẾM NGƯỢC SUBATHON (chèn vào OBS, không cần đăng nhập).
  subathonScreen: '/subathon-screen/:contentCreatorId',
  // Overlay BẢNG XẾP HẠNG DONATE (chèn vào OBS, không cần đăng nhập, tuỳ chọn trên link).
  topDonateScreen: '/top-donate-screen/:contentCreatorId',
  // Bảng điều khiển phát nhạc của streamer (cần đăng nhập).
  musicControl: '/phat-nhac/dieu-khien',
  // Overlay HỎI ĐÁP AI (chèn vào OBS, không cần đăng nhập, link có ?key=).
  aiQuestionScreen: '/hoi-dap-screen/:contentCreatorId',
  // Bảng điều khiển hỏi đáp AI của streamer (cần đăng nhập).
  aiQuestionControl: '/hoi-dap-ai/dieu-khien',
  // Link tiếp thị rút gọn: cab.vn/go/{code} -> đếm click -> sang sản phẩm thật.
  affiliateGo: '/go/:code',
  // Trang sản phẩm CÔNG KHAI (đích của link tiếp thị) — xem không cần đăng nhập.
  publicProduct: '/p/:productId',
  group: '/group',
  groupDetail: '/group/:groupId',
  admin: '/admin',
  adminLogin: '/admin/login',
  dating: '/dating',
  hashtag: '/hashtag/:hashtagId',
  category: '/category/:categoryId',
  old: '/old',
  // Bảng vinh danh CÔNG KHAI (top follow/donate/nhận donate/tương tác) — xem không cần đăng nhập.
  honor: '/vinh-danh',
  // Trang sự kiện thử thách donate CÔNG KHAI — xem không cần đăng nhập.
  donateEvent: '/su-kien/:id',
  // Sàn chiến dịch CÔNG KHAI — ai cũng xem được chiến dịch đang tìm creator, nhận việc mới cần đăng nhập.
  campaigns: '/campaigns',
  campaignDetail: '/campaigns/:campaignId',
  resetPassword: '/account/resetpassword',
  donateGoal: '/donate-goal',
  donate: '/donate',
  wallet: '/wallet',
  marketplace: '/store',
  cabPlus: '/account/cabplus',
  inventory: '/inventory',
  clan: '/clan',
  clanDetail: '/clan/:clanId',
  arena: '/arena',
  arenaDetail: '/arena/:challengeId',
  // Creator: nhận lời mời hợp tác quảng cáo trực tiếp từ doanh nghiệp (Brand Deal).
  brandDeals: '/collab',
  // Người thuê creator: tạo chiến dịch, brief, đơn nhận đề xuất (trang riêng, tách khỏi phía creator và Cab Ads).
  brandOrderer: '/hire-creators',
  // Creator: bàn soạn bài 1 nhiệm vụ brief sáng tạo (M3).
  brandTaskWorkspace: '/collab/task/:dealId',
  // Hồ sơ đánh giá của người đặt (cần đăng nhập).
  brandOrdererProfile: '/collab/orderer/:adAccountId',
};
